SubscriptionController.$inject = ['$rootScope', 'SubscriptionService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function SubscriptionController($rootScope, SubscriptionService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      SubscriptionService.getSubscription(profileId, $stateParams.slug).then(res => {
        vm.subscription = res.data
        copy = angular.copy(vm.subscription)
      })
    }
  })

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.subscription.isPromoted = !vm.subscription.isPromoted
  }
  vm.setPublished = function() {
    vm.subscription.isPublished = !vm.subscription.isPublished
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    SubscriptionService.deleteSubscription(vm.subscription).then(() => $state.go('shell.subscriptions'))
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.subscription, copy)) return SubscriptionService.putSubscription(vm.subscription)
  }, {invokeLimit: 1})
}